import { useEffect, useState } from "react";

const urlParam = "endUrl";
const targetParam = "endTarget";
const codeParam = "Code";

export type TSearch = {
  endUrl: string;
  target: "_blank" | "_self" | "_parent" | "_top" | string;
  code?: string;
};
export const useQuerystring = () => {
  const [search, setSearch] = useState<TSearch>({
    endUrl: "",
    target: "_self",
  });
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const endUrl = params.get(urlParam);
    const target = params.has(targetParam) ? params.get(targetParam) : search.target;
    const code = params.has(codeParam) ? params.get(codeParam) : undefined;
    setSearch({ endUrl, target, code });
  }, [window.location.search]);
  return search;
};
